<template>
  <div class="i-info">
    <div id="process" class="ii-process sticky" >
      <div class="step" :class="{ isActived: actived === 1 }" v-if="productInfo.overview" @click="handleStep(1)">
        <span>{{ $t('main.Overview') }}</span>
      </div>
      <div class="step" :class="{ isActived: actived === 2 }" v-if="productInfo.specs">
        <span @click="handleStep(2)">{{ $t('main.Specifications') }} </span>
      </div>
      <div class="step" :class="{ isActived: actived === 3 }" @click="handleStep(3)" v-if="productInfo.curve">
        <span>{{ $t('main.CoatingCurve') }}</span>
      </div>
      <div class="step" :class="{ isActived: actived === 4 }" @click="handleStep(4)" v-if="productInfo.drawing" >
        <span>{{ $t('main.Drawing') }}</span>
      </div>
      <div class="step" :class="{ isActived: actived === 7 }" @click="handleStep(7)" v-if="productInfo.mark" >
        <span>{{ $t('main.Mark') }}</span>
      </div>
      <div class="step" :class="{ isActived: actived === 5 }" @click="handleStep(5)" v-if="productInfo.guide">
        <span>{{ $t('main.SelectionGuide') }}</span>
      </div>
    </div>

    <div class="ii-content">
      <div class="cu_title" id="tag2" v-if="actived == 1">
        <div>{{ $t('main.Overview') }}</div>
      </div>
      <div class="cont" v-if="actived == 1">
        <div v-html="productInfo.overview"></div>
      </div>
      <div class="cu_title" id="tag3" v-if="actived == 2">
        <div>{{ $t('main.Specifications') }}</div>
      </div>
      <div class="cont" v-if="actived == 2">
        <div class="specs" v-html="productInfo.specs"></div>
      </div>
      <div class="cu_title" id="tag4" v-if="actived == 3">
        <div>{{ $t('main.CoatingCurve') }}</div>
      </div>
      <div class="cont fac" v-if="actived == 3">
           <div v-html="productInfo.curve"></div>
      </div>
      <div class="cu_title" id="tag5" v-if="actived == 4">
        <div>{{ $t('main.Drawing') }}</div>
      </div>
      <div class="cont" v-if="actived == 4">
        <div v-html="productInfo.drawing"></div>
      </div>
      <div class="cu_title" id="tag7" v-if="actived == 7">
        <div>{{ $t('main.Mark') }}</div>
      </div>
      <div class="cont" v-if="actived == 7">
        <div v-html="productInfo.mark"></div>
      </div>

      <div class="cu_title" id="tag6" v-if="actived == 5">
        <div>{{ $t('main.SelectionGuide') }}</div>
      </div>
      <div class="cont" v-if="actived == 5">
        <div v-html="productInfo.guide"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductInfo, reportApi } from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      actived: 1,
      input: "",
      num: "",
      textarea: "",
      steps: [],
      typeList: [],
      productInfo: {},
      customInfo: {},
      reportInfo: {
        email: "",
        content: ""
      },
      page: 1
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))) {
        this.steps = this.treeToArray(JSON.parse(localStorage.getItem("productTypeNav_" + Cookies.get("siteInfo"))));
        let nowProductType = this.steps.find(item => {
          if (item.identification) {
            return this.$route.params.identification == item.identification;
          } else {
            return this.$route.params.identification == item.id;
          }
        });
        if (nowProductType) {
          let id = nowProductType.id;
          let fatherTarget = this.steps.find(item => item.id == nowProductType.pid);
          this.typeList = this.steps.filter(item => item.pid == fatherTarget.pid);
          this.getInfo(id);
        }
      }
    },
    getInfo(id) {
      let params = {
        req: {
          id: id
        }
      };
      getProductInfo(params).then(res => {
        if (res.rsp.code === 0) {
          this.$emit("child-event", res.data);
          this.productInfo = res.data;
          if(this.productInfo.overview){
            this.actived = 1
            return;
          }
          if(this.productInfo.specs){
            this.actived = 2
            return;
          }
          if(this.productInfo.curve){
            this.actived = 3
            return;
          }
          if(this.productInfo.drawing){
            this.actived = 4
            return;
          }
          if(this.productInfo.mark){
            this.actived = 7
            return;
          }
          if(this.productInfo.guide){
            this.actived = 5
            return;
          }else{
            this.actived = 6
          }
        }
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      if (data) {
        auxiliary(data);
      }
      return res;
    },
    handleReport() {
      let params = {
        req: {
          ...this.reportInfo,
          content_id: 0,
          site_id: Cookies.get("siteInfo"),
          product_id: this.productInfo.id
        }
      };
      reportApi(params).then(res => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: "success"
          });
          this.reportInfo = {
            email: "",
            content: ""
          };
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
          this.reportInfo = {
            email: "",
            content: ""
          };
        }
      });
    },
    backonly(){
      this.actived = 6;
    },
    productDetail(){
      this.getInfo(this.productInfo.id);
    },
    handleStep(v) {
      this.actived = parseInt(v);
      this.$emit("clickStep");
    },
  }
};
</script>
<style scoped lang="less">
.cont {
  /deep/ * {
    font-family: Alibaba PuHuiTi,serif !important;
  }
}

.i-info {
  position: relative;

  .ii-title {
    font-size: 1.875rem;
    font-family: YouSheBiaoTiHei,serif;
    font-weight: 400;
    color: #333333;
    padding: 1.75rem 0 3rem;
  }
  .ii-process {
    height: 30px;
    line-height: 30px;
    background: #f2f2f2;
    .step {
      font-size: 1.1428rem;
      color: #FFF;
      float: left;
      padding: 0 20px;
      margin: 0 20px 0 0;
      min-width: 100px;
      text-align: center;
      border-radius: 0.2rem;
      cursor: pointer;
      position: relative;
      background: #B8B0D4;
      &:hover {
        background: #635796;
        color: #FFF;
        &:before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: calc(50% - 2.5px);
          width: 10px;
          height: 10px;
          background: #635796;
          transform: rotate(45deg);
        }
      }
      &:not(:last-child):after {
        content: '';
        float: right;
        width: 2px;
        height: 20px;
        background: #635796;
        right: -10px;
        top: 5px;
        position: absolute;
      }
    }

    .isActived {
      background: #635796;

      &:before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: calc(50% - 2.5px);
        width: 10px;
        height: 10px;
        background: #635796;
        transform: rotate(45deg);
      }
    }
  }

  .ii-content {
    margin-bottom: 2rem;

    table{
      table-layout: fixed;
      width: 100% !important;
      height: auto;
      border: 1px solid #DDD;

      td{
        white-space: normal !important;
        word-wrap: break-word !important;
        padding: 5px 10px;
        border: 1px solid #DDD;
        color: #666666;

        & span, & p{
          color: #666666;
        }
      }
    }

    .cu_title {
      margin: 1rem 0;
      font-size: 1.875rem;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #666666;
    }

    .cImg {
      width: 26px;
    }
  }

  .dz-box {
    background: #fbfbfb;
    padding-top: 2.5rem;

    .dz-l {
      width: 55%;
      border-right: 1px solid #d8d9dc;

      /deep/ .el-input__inner {
        border: 0px;
        border-bottom: 1px solid #d8d9dc;
        background-color: #fbfbfb;
      }
    }
  }

  /deep/ .facab{
    justify-content:flex-start;
  }

  .tjBtn {
    width: 86px;
    height: 32px;
    background: #635796;
    border-radius: 4px;
    color: #fff;
    padding: 0;
    position: absolute;
  }
  @media screen and (max-width: 1400px) {
    .ii-process,
    .ii-content {
      padding: 0 2%;
    }
    .tjBtn {
      right: 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .ii-process,
    .ii-content {
      padding: 0 10%;
    }
    .tjBtn {
      right: 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .ii-process,
    .ii-content {
      padding: 0 15%;
    }
    .tjBtn {
      right: 15%;
    }
  }
}

.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  background: #fff;
}


</style>
<style>
.i-info .ii-content .cont table{
  table-layout: fixed;
  width: 100% !important;
  height: auto;
  border: 1px solid #DDD;
}
.i-info .ii-content .cont table td{
  white-space: normal !important;
  word-wrap: break-word !important;
  padding: 5px 10px;
  border: 1px solid #DDD;
  color: #666666 !important;
  font-size: 14px !important;
}
.i-info .ii-content .cont table td span,
.i-info .ii-content .cont table td p{
  color: #666666 !important;
  font-size: 14px !important;
}
</style>
